<template>
  <article>
    <h1 class='text-uppercase mb-5'>{{ blog.name }}</h1>

    <section>
      <figure>
        <img
          :src='blog.base_image'
          :alt="`${blog.name}'s picture'`"
        />
      </figure>

      <div>
        <p class='blog-body' v-html='extractIframe(blog.body).hasIframe ? extractIframe(blog.body).iframeTag: extractIframe(blog.body).content'></p>
      </div>

      <div class='my-5'>
        <span class='text-muted'>The entry was posted on </span>
        <span>{{ blog.created_at }}</span>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'BlogPage',
  props: { blog: { type: Object, required: true } },
  methods: {
    extractIframe(htmlString) {
      // Create a DOM parser
      const parser = new DOMParser();

      // Decode HTML entities if necessary
      const decodedHtmlString = htmlString.replace(/&lt;/g, "<").replace(/&gt;/g, ">");

      // Parse the HTML string into a document
      const doc = parser.parseFromString(decodedHtmlString, "text/html");

      // Find the iframe element
      const iframe = doc.querySelector("iframe");

      if (!iframe) {
        // Return the entire value if no iframe is found
        return { content: htmlString, hasIframe: false };
      }

      // Extract iframe properties
      const iframeProps = {};
      Array.from(iframe.attributes).forEach(attr => {
        iframeProps[attr.name] = attr.value;
      });

      return {
        iframeTag: iframe.outerHTML,
        iframeProps: iframeProps,
        hasIframe: true
      };
    }
  }
}
</script>

<style>
figure {
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 624px;
  }
}

.blog-body {
  p {
    display: flex;

    img {
      width: 500px;
      margin: 16px auto;
    }
  }
}
</style>
